import {
  ArrowLeftRight,
  LifeBuoy,
  Lightbulb,
  TriangleAlert,
  type LucideIcon,
} from "lucide-react";

export type RequestTypeId = "change" | "incident" | "feature" | "help";

export interface RequestTypeInfo {
  id: RequestTypeId;
  label: string;
  /** One line under the label, telling the customer when to pick this type. */
  description: string;
  Icon: LucideIcon;
}

/**
 * The four kinds of ticket a customer can open from Technical Support. The
 * cards on the page and the header of each modal both read from here, so a
 * type is named and described the same way in both places (CTX-1256).
 */
export const REQUEST_TYPES: Record<RequestTypeId, RequestTypeInfo> = {
  change: {
    id: "change",
    label: "Change Request",
    description: "Modify a service or its configuration.",
    Icon: ArrowLeftRight,
  },
  incident: {
    id: "incident",
    label: "Incident Report",
    description: "Something is down or not working as expected.",
    Icon: TriangleAlert,
  },
  feature: {
    id: "feature",
    label: "Feature Request",
    description: "Suggest something new for the platform.",
    Icon: Lightbulb,
  },
  help: {
    id: "help",
    label: "Help Request",
    description: "Ask us a question about your services.",
    Icon: LifeBuoy,
  },
};

export const REQUEST_TYPE_ORDER: RequestTypeId[] = [
  "change",
  "incident",
  "feature",
  "help",
];
